const localeDemo_CN = {
  text: '人生不止眼前的苟且，还有诗与远方',
};

export default localeDemo_CN;